import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {toggleModal} from '../store/actions/toggleModalActions';
import {getUsers, selectUser, usersError, clearUserDeviceIds, deleteUser} from '../store/actions/usersActions';
import './Users.scss';

import List from './_common/List';
import ErrorModal from './_common/ErrorModal';
import DeleteModal from './_common/DeleteModal';
// import UserDetails from './UserDetails';
import ChoiceModal from "./_common/ChoiceModal";

const selector = state => {
    const { language, users, modalState } = state;
    return {
        t: language.translator,
        pending: users.pending,
        users: users.users,
        pagination: users.pagination,
        selected: users.selected,
        error: users.error,
        modalState: modalState
    };
};

const Users = () => {
    const { t, pending, users, pagination, selected, error, modalState } = useSelector(selector);
    const dispatch = useDispatch();
    const [searchInput, setSearchInput] = useState('');
    const [searchApplied, setSearchApplied] = useState(false);

    // const [showAddUserForm, setShowAddUserForm] = useState(false);

    useEffect(() => {
        dispatch(getUsers({}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const handleUserClick = id => {
    //     setShowAddUserForm(false);
    //     dispatch(selectUser(id ? users.find(user => user.id === id) : {}));
    // };
    //
    const openDeleteUserModal = id => {
        dispatch(selectUser(users.find(user => user.id === id)));
        dispatch(toggleModal(true, 'deleteUser'));
    };

    const handleClearDeviceIdsClick = id => {
        dispatch(selectUser(users.find(user => user.id === id)));
        dispatch(toggleModal(true, 'clearUserDeviceIds'));
    };

    const confirmClearDeviceIds = () => {
        dispatch(clearUserDeviceIds(selected.id))
        dispatch(toggleModal(false, ''));
    };

    const closeModal = () => {
        dispatch(selectUser({}));
        dispatch(toggleModal(false, ''));
    }

    const searchUsers = () => {
        setSearchApplied(true);
        dispatch(getUsers({page: 1, search: searchInput}));
    };

    const clearUsersSearch = () => {
        setSearchInput('');
        setSearchApplied(false);
        dispatch(getUsers({}));
    };

    return (
        <div className='page'>
            <div className='pageHeader'>
                <div className='pageHeaderLeft'>
                    <div className='pageHeaderTitle'>
                        {t.gettext('Users')}
                    </div>
                </div>
            </div>
            <div className='Users'>
                {/*<div className='column column--first'>*/}
                <div className='column column100'>

                    <div className='columnHeader'>
                        <div className='columnHeaderLeft'>
                            {t.gettext('Users list')}
                        </div>

                        <div className='columnHeaderCenter'>
                            <div className='searchBarContainer'>
                                <input
                                    className='searchBarInput'
                                    type='text'
                                    value={searchInput}
                                    onChange={e => setSearchInput(e.target.value)}
                                    placeholder={t.gettext('Search...')}
                                    disabled={searchApplied}
                                />
                                <button
                                    className='searchBarButton'
                                    onClick={searchUsers}
                                    disabled={!searchInput || searchApplied}
                                >
                                    <span className='material-icons searchBarButtonIcon'>
                                        search
                                    </span>
                                </button>
                                {searchApplied &&
                                    <button
                                      className='searchBarClearButton'
                                      onClick={clearUsersSearch}
                                    >
                                        <span className='material-icons searchBarClearButtonIcon'>
                                            cancel
                                        </span>
                                    </button>
                                }
                            </div>
                        </div>

                        <div className='columnHeaderRight'>
                        {/*    <button*/}
                        {/*        className='columnHeaderButton'*/}
                        {/*        onClick={() => {*/}
                        {/*            dispatch(selectUser({}));*/}
                        {/*            setShowAddUserForm(true);*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        <span className="material-icons columnHeaderButtonIcon">*/}
                        {/*            add*/}
                        {/*        </span>*/}
                        {/*    </button>*/}
                        </div>
                    </div>

                    <div className='usersListWrapper'>
                        <List
                            pending={pending}
                            items={users}
                            columnsTitles={['User Id', 'Login', 'Name', 'Last Login']}
                            columnsSources={['id', 'email', 'firstName', 'lastLoginDate']}
                            columnsWidths={['20%', '30%', '30%', '20%']}
                            dateAndTimeColumns={[4]}
                            deleteMethod={openDeleteUserModal}
                            // selectMethod={handleUserClick}
                            selectedItem={Object.keys(selected).length !== 0 && selected.constructor === Object
                                ? selected.id
                                : null
                            }
                            customButtonText={'Clear device IDs'}
                            customButtonMethod={handleClearDeviceIdsClick}
                            pagination={pagination}
                            getItemsMethod={page => {dispatch(getUsers({page: page, search: searchApplied ? searchInput : ''}))}}
                            highlight
                        />
                    </div>

                    {modalState.flag && modalState.modal === 'deleteUser' &&
                        <DeleteModal
                            id={selected.id}
                            itemName={selected.email}
                            title='Delete user'
                            deleteMethod={() => dispatch(deleteUser(selected.id))}
                            closeMethod={closeModal}
                        />
                    }

                    {modalState.flag && modalState.modal === 'clearUserDeviceIds' &&
                        <ChoiceModal
                            text={t.gettext("Are you sure you want to clear selected user's device IDs") + '?'}
                            confirmMethod={confirmClearDeviceIds}
                            closeMethod={closeModal}
                        />
                    }

                    {!!error &&
                        <ErrorModal
                            error={error}
                            closeMethod={() => dispatch(usersError(''))}
                        />
                    }

                </div>
                {/*<div className='column'>*/}
                {/*    {Object.keys(selected).length !== 0 && selected.constructor === Object &&*/}
                {/*        <UserDetails*/}
                {/*            user={selected}*/}
                {/*        />*/}
                {/*    }*/}
                {/*    {showAddUserForm &&*/}
                {/*        <UserDetails*/}
                {/*            closeAddForm={() => setShowAddUserForm(false)}*/}
                {/*        />*/}
                {/*    }*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default Users;
